/**
 * DevExtreme (esm/__internal/grids/new/grid_core/widget_mock.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export class WidgetMock {
    constructor(widget, data, columns, headerFilter, filterSync) {
        this.widget = widget;
        this.data = data;
        this.columns = columns;
        this.headerFilter = headerFilter;
        this.filterSync = filterSync;
        this.NAME = "dxDataGrid";
        this._controllers = {
            data: this.data,
            columns: this.columns,
            headerFilter: this.headerFilter,
            filterSync: this.filterSync
        }
    }
    option() {
        return this.widget.option(...arguments)
    }
    columnOption() {
        return this.widget.columnOption(...arguments)
    }
    _createActionByOption() {
        return this.widget._createActionByOption(...arguments)
    }
    _createComponent() {
        return this.widget._createComponent(...arguments)
    }
}
